import React, { useState, useEffect } from "react";
import Select from "react-select";
import moment from "moment";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import fr from "date-fns/locale/fr";
registerLocale("fr", fr);

const rangeOptions = [
    { value: "0;500", label: "0 € - 500 €" },
    { value: "500;1000", label: "500 € - 1000 €" },
    { value: "1000;1500", label: "1000 € - 1500 €" },
    { value: "1500;2000", label: "1500 € - 2000 €" },
    { value: "2000;3000", label: "2000 € - 3000 €" },
    { value: "3000;4000", label: "3000 € - 4000 €" },
    { value: "4000;5000", label: "4000 € - 5000 €" },
];

const SearchPropertyMessage = ({ message, axios }) => {
    const [payload, setPayload] = useState({
        city: 5,
        date: new Date(),
        price_range: "1000;1500",
    });

    let ajaxRequest = null;

    useEffect(() => {
        const priceRangeChoices = new Choices(
            document.querySelector("#price_" + message.id),
            {
                loadingText: "...",
                noResultsText: "",
                noChoicesText: "",
                itemSelectText: "",
            }
        );

        const choices = new Choices(
            document.querySelector("#city_" + message.id),
            {
                searchEnabled: true,
                searchChoices: true,
                loadingText: "...",
                noResultsText: "",
                noChoicesText: "",
                itemSelectText: "",
                searchResultLimit: 7,
            }
        );
        choices.passedElement.element.addEventListener(
            "search",
            function (event) {
                if (event.detail.value && event.detail.value.length == 0)
                    return;
                console.log(event.detail);
                choices.clearChoices();
                choices.setChoices(function () {
                    var formData = new FormData();
                    formData.append("q", event.detail.value);
                    ajaxRequest = axios.CancelToken.source();
                    return axios
                        .post("/newchatbot/cities", formData, {
                            cancelToken: ajaxRequest.token,
                        })
                        .then(function (response) {
                            if (response.data.success) {
                                return response.data.data;
                            }
                            return [];
                        })
                        .catch((error) => {
                            console.log(error);
                            return [];
                        });
                });
            },
            false
        );
    }, []);

    const onSearchHandler = () => {
        console.log(payload);
        const params = new URLSearchParams({
            "cities[]": payload.city,
            start_date: moment(payload.date).format("DD/MM/yyyy"),
            price_range: payload.price_range,
        });
        const str = params.toString();
        window.open("/properties?" + params.toString(), "_blank").focus();
    };

    return (
        <div style={{ width: "100%", margin: "20px 0" }}>
            <label>
                Où souhaitez vous habiter ?
                <select
                    id={"city_" + message.id}
                    value={payload.city}
                    multiple={true}
                    onChange={(event) => {
                        setPayload((old) => {
                            return { ...old, city: event.target.value };
                        });
                        console.log(event.target.value);
                    }}
                ></select>
            </label>
            <div className="d-block mt-h">
                Quand souhaitez vous emménager ?
                <DatePicker
                    locale="fr"
                    selected={payload.date}
                    onChange={(date) => {
                        setPayload((old) => {
                            return { ...old, date };
                        });
                        console.log(date);
                    }}
                    inline
                    minDate={new Date()}
                    dateFormat="DD/MM/yyyy"
                />
            </div>
            <label className="d-block mt-h">
                Quel est votre budget maximum (charges comprises hors
                électricité) ?
                <select
                    id={"price_" + message.id}
                    value={payload.price_range}
                    onChange={(event) => {
                        setPayload((old) => {
                            return { ...old, price_range: event.target.value };
                        });
                        console.log(event.target.value);
                    }}
                >
                    {rangeOptions.map((option, i) => {
                        return (
                            <option key={i} value={option.value}>
                                {option.label}
                            </option>
                        );
                    })}
                </select>
            </label>
            <button
                className={"btn btn-white btn-block text-center mt-1"}
                onClick={onSearchHandler}
            >
                Chercher <i className="fas fa-search mr-h"></i>
            </button>
        </div>
    );
};

export default SearchPropertyMessage;
